export const name = "ST_EQUALS";
export const summary = `Checks if two \`GEOGRAPHY\` values represent the same \`GEOGRAPHY\` value.`;
export const reference = `
## ST_EQUALS

Checks if two \`GEOGRAPHY\` values represent the same \`GEOGRAPHY\` value.

\`\`\`
ST_EQUALS(geography_1, geography_2)
\`\`\`

### Description

Checks if two \`GEOGRAPHY\` values represent the same \`GEOGRAPHY\` value. Returns\`TRUE\` if the values are the same, otherwise returns \`FALSE\`.


### Definitions

- \`geography_1\`: The first \`GEOGRAPHY\` value to compare.
- \`geography_2\`: The second \`GEOGRAPHY\` value to compare.


### Details

As long as they still represent the same geometric structure, two\`GEOGRAPHY\` values can be equal even if the ordering of points or vertices differ. This means that one of the following conditions must be true for this function to return \`TRUE\`:

- Both \`ST_COVERS(geography_1, geography_2)\` and\`ST_COVERS(geography_2, geography_1)\` are \`TRUE\`.
- Both \`geography_1\` and \`geography_2\` are empty.

\`ST_EQUALS\` isn't guaranteed to be a transitive function.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
